export const BlogsData=[
    {
    id: 1,
    title: "Contact",
    body: "MD. MOTALEB HOSSAIN, Kagmara, Tangail Sadar, Tangail Sadar, Tangail 1900, contact phone icon 01911542763, 01686695594, email icon motaleb.it@gmail.com",
},
{
    id: 2,
    title: "Career",
    body: "To prove myself as a quick to face any Challenging in such as Reputed Organization where creativity a sense of responsibility, hard working, and honesty will be appreciated, using my experience where will be acknowledge if getting an opportunity",
},

{
    id: 3,
    title: "Experience",
    body: "1. I have experience on Oracle e-business suite (EBS) 2. Web Base Software Development (HTML,CSS, Bootstrap, Php and php Framework, React.Js, JavaScript,Jquery,ajax) 3. Oracle SQL, PLSQL 4. Web Project Name: Quality Control System, Product Live Received, Admin Solution System.",
},
{
    id: 4,
    title: "Employment",
    body: "Total Year of Experience: 13.5 yrs 1. Sr. Executive (Oracle EBS) (9.6 yrs) (1 Jul 2014 - Continuing) Walton Hi-Tech Industries PLC.Area of Expertise: ORACLE EBS R12 (3 yrs), Software Developer (4.5 yrs) Duties/Responsibilities: a) I ensured to support almost 5k users (Business Logic, Functional, Exception Handle & Reporting) of Oracle e-business suite (EBS) b) Web Base Software Development, Implementation & Support. c) Designing database structure creating required Data Migration, tables, views, sequences, database triggers, packages, functions, procedures etc d) Communicating with Oracle Vendor Company for Complex issues. e) Personalization of new requirement in Oracle EBS system as per business requirements.",
},



];